<template>
  <div>
    <div class="banner">
      <!-- 第一屏 -->
      <div style="width: 100%; height: 1080px"></div>
      <div style="width: 100%; height: 100%">
        <div style="position: fixed; top: 0; left: 0; z-index: 99; width: 100%"
             ref="heads"
             @mouseenter="handleMouseEnter"
             @mouseleave="handleMouseleave">
          <headers></headers>
        </div>

        <img style="width: 100%; position: absolute; top: 0; height: 1080px"
             src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/11/images_1744359088483.jpg"
             alt="安徽继续教育网" />
        <div class="bgc">
          <div class="fsk">
            <div style="width: 1048px">
              <div class="flexCenter">
                <img style="width: 665px; height: 49px"
                     src="../assets/indexImg/logo23@2x.png"
                     alt="安徽继续教育网" />
              </div>
              <div class="txt1">专业技术人员继续教育培训、职业技术培训的专业化学习培训平台</div>
              <!-- <div class="swInput flexCenter">
                <div style="display: flex">
                  <input class="searCh" v-model="className" placeholder="输入您感兴趣的班级名称" />
                  <div class="searBtn" @click="searClass">搜 索</div>
                </div>
              </div> -->
              <div style="display: flex;justify-content: space-between;">
                <div class="jtBox"
                     @click="handleJiti"><img src="../assets/images/Group 1353@2x.png"
                       alt=""></div>
                <div class="jtBox"
                     @click="handleInvited"><img src="../assets/images/Group 1350@2x.png"
                       alt=""></div>
              </div>
              <div class="listBox">
                <!-- 中间的竖线 -->
                <div class="su"></div>
                <div class="zjBox">
                  <div style="display: flex; justify-content: space-between; height: 56px">
                    <div style="display: flex; align-items: center">
                      <div style="display: flex; align-items: center">
                        <img src="../assets/indexImg/zj.png"
                             alt="安徽继续教育网" />
                      </div>
                      <div style="color: #24bd59; font-weight: bold; margin-left: 4px">专技继续教育</div>
                    </div>
                    <!-- <div @click="handleJiti">
                      <img src="../assets/images/jiti1.png" alt="" style="width: 188px; height: 50px; cursor: pointer" />
                    </div> -->
                  </div>

                  <div class="cpBox">
                    <div class="lBxp"
                         v-for="item in jxjyCodeList"
                         :key="item.id"
                         @click="goXk(item)">{{ item.codeName }}</div>
                  </div>

                  <div class="flexCenter"
                       style="width: 332px">
                    <div class="btnMore"
                         @click="goXk('')">了解更多</div>
                  </div>
                </div>
                <div class="zjBox"
                     style="padding-left: 73px">
                  <div style="display: flex; justify-content: space-between; height: 56px">
                    <div style="display: flex; height: 56px; align-items: center">
                      <div style="display: flex; align-items: center">
                        <img src="../assets/indexImg/zy.png"
                             alt="安徽继续教育网" />
                      </div>
                      <div style="color: #ff8833; font-weight: bold; margin-left: 4px">职业技术培训</div>
                    </div>
                    <!-- <div @click="handleInvited">
                      <img src="../assets/images/newUser.png" alt="" style="width: 188px; height: 50px; cursor: pointer" />
                    </div> -->
                  </div>
                  <div class="cpBox">
                    <div class="lBxp"
                         v-for="item in zypxCodeList"
                         :key="item.id"
                         @click="gotoZydetail(item.codeNo)">
                      {{ item.codeName }}
                    </div>
                  </div>

                  <div class="flexCenter"
                       style="width: 332px"
                       @click="gotoListFs">
                    <div class="btnMore btnMoreHover">了解更多</div>
                  </div>
                </div>
              </div>
              <div class="listBox2">
                <div class="fwBox"
                     v-for="item in kstdCodeList"
                     :key="item.id"
                     @click="goKstd(item)">
                  <div style="padding: 20px"
                       class="borBox">
                    <div class="txt2">
                      <div><img src="../assets/indexImg/11.png"
                             alt="安徽继续教育网" /></div>
                      <div style="margin-left: 8px; color: #fff">{{ item.codeName }}</div>
                    </div>
                    <div class="txt3">{{ item.codeDesc == null ? '暂无介绍' : item.codeDesc }}</div>
                  </div>
                  <div class="bor"></div>
                  <div class="txt4">立即进入</div>
                </div>
              </div>
              <div class="jiti">
                <div style="display: flex; align-items: center">
                  <div class="jintuText">集体报名</div>
                  <div class="jinru_1">高效解决批量报名需求，省时省力、批量开通、统一管理</div>
                </div>
                <div class="jinru_btn"
                     @click="handleJiti">立即进入</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二屏 -->
      <div class="jyBox">
        <div class="js">
          <div class="flexCenter head1">专业技术人员继续教育</div>
          <div class="flexCenter head2">面向专业技术人员，聚焦知识更新、能力提升，涵盖多领域的持续学习体系</div>
          <div class="iconBox">
            <div class="ib"
                 @click="jxjyClass(item.id, index)"
                 v-for="(item, index) in jxjyHotCodeList"
                 :key="item.id">
              <img :style="jxjyIndex == index ? 'opacity: 1' : ''"
                   class="showImg"
                   src="../assets/indexImg/1111.png"
                   alt="安徽继续教育网" />
              <div class="flexCenter">
                <img :src="
                    index == 0
                      ? img1
                      : index == 1
                      ? img10
                      : index == 2
                      ? img2
                      : index == 3
                      ? img3
                      : index == 4
                      ? img4
                      : index == 5
                      ? img5
                      : index == 6
                      ? img6
                      : index == 7
                      ? img7
                      : index == 8
                      ? img8
                      : index == 9
                      ? img9
                      : img1010
                  "
                     :alt="item.codeName" />
              </div>
              <div class="txt9"
                   style="margin: 8px 0; text-align: center">{{ item.codeName }}</div>
            </div>

            <div class="ib1"
                 @click="goMore">
              <img class="showImg"
                   src="../assets/indexImg/1111.png"
                   alt="安徽继续教育网" />
              <div class="flexCenter">
                <img :src="img9" />
              </div>
              <div class="txt9"
                   style="margin: 8px 0; text-align: center">查看更多</div>
            </div>
          </div>
        </div>
      </div>

      <div class="kc"
           :style="jxjyIndex == null ? 'height:1130px' : ''">
        <img class="bgcs"
             :style="jxjyIndex == null ? 'height:1130px' : ''"
             src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/08/images_1744078527686.png"
             alt="安徽继续教育网" />
        <div>
          <div class="kcList"
               v-show="jxjyIndex !== null">
            <div style="width: 100%; text-align: center; padding-top: 120px; font-size: 22px"
                 v-if="zyjsEmpty">暂无班级数据~</div>
            <div class="kcB"
                 v-for="item in zyjsList"
                 :key="item.id"
                 @click="goDetail(item.id, '1')"
                 :title="item.className">
              <div>
                <div v-if="item.classImage == null"
                     class="fm"
                     :alt="item.className"
                     :title="item.className"
                     style="position: relative; display: flex; justify-content: center; align-items: center">
                  <img class="fmImg"
                       style="border-radius: 8px"
                       src="../assets/indexImg/noimg.png"
                       :alt="item.className" />

                  <div class="imgText">
                    {{ item.className }}
                  </div>
                </div>
                <img v-else
                     :alt="item.className"
                     :title="item.className"
                     class="fm"
                     style="border-radius: 8px"
                     :src="item.classImage" />
              </div>
              <div style="margin-left: 16px">
                <div class="bt">{{ item.className }}</div>
                <div class="fl">
                  <div class="flx">{{ item.lx }}</div>
                  <div class="flx">{{ item.classCredithour }}学时</div>
                  <div class="flx">继续教育</div>
                </div>
                <div class="studyTime">报名时间：{{ item.classEnrolStarttime }} ~ {{ item.classEnrolEndtime }}</div>
                <div class="studyTime">上课时间：{{ item.classStarttime }} ~ {{ item.classEndtime }}</div>
                <div class="btm">
                  <div style="display: flex; margin-top: 14px">
                    <div style="font-size: 14px; margin-top: 5px; font-weight: 800">¥</div>
                    <div style="font-size: 20px; font-weight: 800"
                         v-if="item.isClassApply == '01' || item.isClassApply == '' || item.isClassApply == null">
                      {{ item.creditPrice }}/<span style="font-size: 13px">学时</span>
                    </div>
                    <div style="font-size: 20px; font-weight: 800"
                         v-else>{{ (item.classPrice || 0).toFixed(1) }}</div>
                  </div>

                  <div class="skBtn">免费试听</div>
                  <div class="skBtn ljgm">立即购买</div>
                </div>
              </div>
            </div>
          </div>

          <div class="newKcList"
               v-show="jxjyIndex == null">
            <div class="newBox"
                 v-for="item in list1"
                 :key="item.id"
                 @click="goDetail(item.id, '1')">
              <div class="fmDiv">
                <img v-if="item.classImage !== null"
                     :src="item.classImage"
                     alt="" />
                <img v-else
                     src="../assets/indexImg/noimg.png"
                     alt=""
                     class="fmImg" />
                <div v-if="item.classImage == null"
                     class="imgText">
                  {{ item.className }}
                </div>
              </div>
              <div class="ntext1">
                {{ item.className }}
              </div>
              <div class="nax">
                <div class="na1">继续教育</div>
                <div class="na1">{{ item.lx }}</div>
                <div class="na1">{{ item.classCredithour }}学时</div>
              </div>
              <div class="pric">
                <div v-if="item.isClassApply == '02'"><span style="font-size: 14px">¥</span>{{ item.classPrice.toFixed(1) }}</div>
                <div v-if="item.isClassApply == '01'"><span style="font-size: 14px">¥</span>{{ item.creditPrice }}/学时</div>
                <div style="font-size: 12px; color: #888888; margin: 8px 0 0 10px"></div>
              </div>
            </div>
          </div>

          <div class="newKcList"
               v-show="jxjyIndex == null">
            <div class="newBox"
                 v-for="item in list2"
                 :key="item.id"
                 @click="goDetail(item.id, '1')">
              <div class="fmDiv">
                <img v-if="item.classImage !== null"
                     :src="item.classImage"
                     alt="" />
                <img v-else
                     src="../assets/indexImg/noimg.png"
                     alt=""
                     class="fmImg" />
                <div v-if="item.classImage == null"
                     class="imgText">
                  {{ item.className }}
                </div>
              </div>
              <div class="ntext1">
                {{ item.className }}
              </div>
              <div class="nax">
                <div class="na1">继续教育</div>
                <div class="na1">{{ item.lx }}</div>
                <div class="na1">{{ item.classCredithour }}学时</div>
              </div>
              <div class="pric">
                <div v-if="item.isClassApply == '02'"><span style="font-size: 14px">¥</span>{{ item.classPrice.toFixed(1) }}</div>
                <div v-if="item.isClassApply == '01'"><span style="font-size: 14px">¥</span>{{ item.creditPrice }}/学时</div>
                <div style="font-size: 12px; color: #888888; margin: 8px 0 0 10px"></div>
              </div>
            </div>
          </div>

          <div class="zxBox">
            <div class="xian"></div>
            <div class="zbs"
                 style="padding-right: 70px">
              <div class="headsw">
                <div class="z1">通知公告</div>
                <div class="z2"
                     @click="goFg('', '1')">
                  <div>更多公告</div>
                  <div><img src="../assets/indexImg/Frame.png"
                         alt="安徽继续教育网" /></div>
                </div>
              </div>
              <div class="xwB"
                   v-for="(item, index) in tzggList"
                   :key="item.ID"
                   @click="goFg(item.ID, '1', index)">
                <div class="xwContent">{{ item.TITLE }}</div>
                <div class="timer">{{ item.PUBLISHTIME }}</div>
              </div>
            </div>

            <div class="zbs"
                 style="padding-left: 70px">
              <div class="headsw">
                <div class="z1">行业资讯</div>
                <div class="z2"
                     @click="goFg('', '2')">
                  <div>更多资讯</div>
                  <div><img src="../assets/indexImg/Frame.png"
                         alt="安徽继续教育网" /></div>
                </div>
              </div>
              <div class="xwB"
                   v-for="(item, index) in hyzxList"
                   :key="item.ID"
                   @click="goFg(item.ID, '2', index)">
                <div class="xwContent">{{ item.TITLE }}</div>
                <div class="timer">{{ item.PUBLISHTIME }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第三屏 -->
      <div class="zyjs">
        <div class="baners">
          <div class="js1">职业技术培训 开始你的高薪之路</div>
          <div class="js2">新时代备受欢迎的就业领域，课程实时更新行业前沿技术与项目</div>

          <div class="navImgList">
            <div style="display: flex">
              <div class="navBox"
                   v-for="(item, index) in zypxHotCodeList"
                   :key="item.id">
                <div @click="handleZy(index)">
                  <img :src="
                      index == 0 ? zyImg1 : index == 1 ? zyImg2 : index == 2 ? zyImg3 : index == 3 ? zyImg4 : index == 4 ? zyImg5 : zyImg5
                    "
                       :alt="item.codeName" />
                </div>
                <div class="tx1"
                     style="text-align: center; font-size: 16px">{{ item.codeName }}</div>
                <div class="tx2"
                     style="text-align: center; font-size: 16px"
                     @click="changeZyhot(item)">立即进入</div>
              </div>
            </div>

            <div class="navBox"
                 @click="gotoListFs">
              <div>
                <img src="../assets/indexImg/ckgd.png"
                     alt="安徽继续教育网" />
              </div>
              <div class="tx1"
                   style="text-align: center; font-size: 16px">查看更多视频</div>
              <div class="tx2"
                   style="text-align: center; font-size: 16px"
                   @click="gotoListFs">立即进入</div>
            </div>
          </div>

          <div class="navTent">
            <div class="left_bgc">
              <img class="img1"
                   src="../assets/indexImg/left_bgc.png"
                   alt="安徽继续教育网" />
              <img class="img2"
                   src="../assets/indexImg/sj.png"
                   alt="安徽继续教育网" />
              <div class="z2"
                   style="margin-top: 37px">
                <span style="font-size: 30px">{{ codeExtendInfo.job }}</span>% 就业率
              </div>
              <div class="z2">
                <span style="font-size: 30px">{{ codeExtendInfo.salary }}</span>元 平均薪资
              </div>
              <div class="z2"
                   style="margin-top: 98px; font-size: 12px; opacity: 0.5">
                学员就业信息统计数据为数据库中实时 获取的真实相关数据，非广告宣传
              </div>
            </div>

            <div class="right_bgc">
              <div class="right_head">
                <img src="../assets/indexImg/right_bgc.png"
                     alt="安徽继续教育网" />
                <div>
                  <div class="tb1">13年深耕教学 全力助你高起点就业</div>
                  <div class="tb2">以技术为核心 以高薪就业为导向提供一站式职业技能培训</div>
                </div>

                <div class="rh1">
                  <div class="l1">老师好</div>
                  <div class="l1">课程好</div>
                  <div class="l1">教学好</div>
                  <div class="l1">就业好</div>
                </div>
              </div>

              <div class="rhi2">
                <div class="r1">{{ codeExtendInfo.codeName }}培训路线全景图</div>
                <div class="r2">
                  <div class="rbox"
                       v-if="codeExtendInfo.infoOneTitle">
                    <div class="rb1">阶段一</div>
                    <div class="rb2">
                      <div class="rb3"
                           :title="codeExtendInfo.infoOneTitle">{{ codeExtendInfo.infoOneTitle }}</div>
                      <div class="rb4"
                           :title="codeExtendInfo.infoOne">{{ codeExtendInfo.infoOne }}</div>
                    </div>
                  </div>
                  <div class="rbox"
                       v-if="codeExtendInfo.infoTwoTitle">
                    <div class="rb1">阶段二</div>
                    <div class="rb2">
                      <div class="rb3"
                           :title="codeExtendInfo.infoTwoTitle">{{ codeExtendInfo.infoTwoTitle }}</div>
                      <div class="rb4"
                           :title="codeExtendInfo.infoTwo">
                        {{ codeExtendInfo.infoTwo }}
                      </div>
                    </div>
                  </div>
                  <div class="rbox"
                       v-if="codeExtendInfo.infoThreeTitle">
                    <div class="rb1">阶段三</div>
                    <div class="rb2">
                      <div class="rb3"
                           :title="codeExtendInfo.infoThreeTitle">{{ codeExtendInfo.infoThreeTitle }}</div>
                      <div class="rb4"
                           :title="codeExtendInfo.infoThree">
                        {{ codeExtendInfo.infoThree }}
                      </div>
                    </div>
                  </div>
                  <div class="rbox"
                       v-if="codeExtendInfo.infoFourTitle">
                    <div class="rb1">阶段四</div>
                    <div class="rb2">
                      <div class="rb3"
                           :title="codeExtendInfo.infoFourTitle">{{ codeExtendInfo.infoFourTitle }}</div>
                      <div class="rb4"
                           :title="codeExtendInfo.infoFour">
                        {{ codeExtendInfo.infoFour }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flexCenter"
                     @click="gotoListFs(codeExtendInfo)">
                  <div class="r3">立即报名</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第四屏就业前景 -->
      <div class="jyqj">
        <img class="jyB1"
             src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/08/images_1744078292724.png"
             alt="安徽继续教育网" />

        <div style="position: relative; z-index: 2; width: 1400px">
          <div class="tj1">职业技术人员就业前景好 工资香 上升快 保障全</div>
          <div class="tj2">拥有职业技术在未来市场具有巨大的竞争力</div>

          <div class="jsmm">
            <div class="left_mm">
              <div class="lt1">解锁职业技术人员就业的黄金密码</div>
              <div class="lt2">
                全面解析职业技术人员就业格局。从前景广阔的行业需求，到丰厚薪资、顺畅晋升，再到完善保障，多维度呈现其就业优势，为你呈现一幅职业技术人员的理想就业蓝图
                。
              </div>
              <div class="lt3">
                <div class="lt5">
                  <div><img src="../assets/indexImg/rcxq.png"
                         alt="安徽继续教育网" /></div>
                  <div class="lt6">人才需求大</div>
                </div>
                <div class="lt5">
                  <div><img src="../assets/indexImg/jyxz.png"
                         alt="安徽继续教育网" /></div>
                  <div class="lt6">就业薪资高</div>
                </div>
                <div class="lt5">
                  <div><img src="../assets/indexImg/szjx.png"
                         alt="安徽继续教育网" /></div>
                  <div class="lt6">升职加薪快</div>
                </div>
                <div class="lt5">
                  <div><img src="../assets/indexImg/qybz.png"
                         alt="安徽继续教育网" /></div>
                  <div class="lt6">权益保障全</div>
                </div>
              </div>
              <div class="lt4">
                <div class="btn2"
                     style="background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%)"
                     @click="gotoListFs">立即报名</div>
                <div class="btn2"
                     style="margin-left: 30px">
                  <a rel="nofollow"
                     target="_blank"
                     href="https://ahgcjykjyxgs.qiyukf.com/client?k=dafbd24366a8c31bb28f2737a1b7698e&wp=1&robotShuntSwitch=0&templateId=8136501&language=zh-cn&t=安徽继续教育网"
                     style="display: block">咨询客服</a>
                </div>
              </div>
            </div>

            <div class="right_mm">
              <div class="rg1">
                <div class="rm1">人才需求大</div>
                <div class="rm2">
                  随着产业升级与新兴技术崛起，智能制造、信息技术、现代服务等领域技能型人才缺口持续扩大，职业教育成为填补缺口的核心渠道。​
                </div>
                <img src="../assets/indexImg/rcxq_h.png"
                     alt="安徽继续教育网" />
              </div>
              <div class="rg1">
                <div class="rm1">就业薪资高</div>
                <div class="rm2">技术性岗位薪资随经验与技能等级提升显著，高级技工、工程师等紧缺人才薪资普遍高于传统行业平均水平。</div>
                <img src="../assets/indexImg/jyxz_h.png"
                     alt="安徽继续教育网" />
              </div>
              <div class="rg1">
                <div class="rm1">升职加薪快</div>
                <div class="rm2">
                  职业教育注重实践能力培养，从业者可凭借扎实的实操技能和项目经验，在企业中快速晋升至技术主管、项目经理等核心岗位，薪资涨幅远超常规路径。
                </div>
                <img src="../assets/indexImg/szhx_h.png"
                     alt="安徽继续教育网" />
              </div>
              <div class="rg1">
                <div class="rm1">权益保障全</div>
                <div class="rm2">
                  国家通过《职业教育法》等法规明确职业教育地位，推动企业落实同工同酬，覆盖社保、培训、职称评定等权益，为职教人才职业发展筑牢制度保障。
                </div>
                <img src="../assets/indexImg/qybz_h.png"
                     alt="安徽继续教育网" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第五屏课程资源库 -->
      <div class="couserBox">
        <div class="w">
          <div class="c1">课程资源库</div>
          <div class="c2">整合了大量优质的教学资源为学习者提供丰富学习资源的数字化平台</div>

          <div class="courNav"
               style="position: relative">
            <div style="display: flex">
              <div :class="index == courseTabIndex ? 'courseName courseNameActive' : 'courseName'"
                   v-for="(item, index) in recommendCourseCodeList"
                   :key="item.ID"
                   @click="findCourseListByRecommend(item.ID, index)">
                {{ item.CODE_NAME }}
              </div>
            </div>

            <div class="z21"
                 @click="goTQ()">
              <div>更多课程</div>
              <div class="z2Bac"></div>
            </div>
          </div>

          <div class="couserList">
            <div v-if="recommendEmpty"
                 style="width: 100%; text-align: center; margin-top: 150px; font-size: 20px">暂无课程数据~</div>
            <div class="kcbRes"
                 v-for="item in recommendCourseList"
                 :key="item.id"
                 @click="goDetail(item.id, '2')"
                 :title="item.CName">
              <div class="kcB">
                <div>
                  <div v-if="item.CImage == null"
                       class="fm"
                       :alt="item.CName"
                       :title="item.CName"
                       style="position: relative; display: flex; justify-content: center; align-items: center">
                    <img :alt="item.CName"
                         :title="item.CName"
                         class="fmImg"
                         src="../assets/indexImg/noimg.png" />

                    <div class="imgText">
                      {{ item.CName }}
                    </div>
                  </div>
                  <img v-else
                       :alt="item.CName"
                       :title="item.CName"
                       class="fm"
                       :src="item.CImage" />
                </div>

                <div style="padding: 0 12px">
                  <div class="bt">{{ item.CName }}</div>
                  <div class="fl">
                    <div class="flx">{{ item.codeName }}</div>
                  </div>

                  <div class="btm">
                    <div style="display: flex">
                      <div style="font-size: 14px; margin-top: 5px">¥</div>
                      <div style="font-size: 20px">{{ (item.CPrice || 0).toFixed(1) }}</div>
                      <!-- <div style="margin-top: 7px; margin-left: 9px; color: #888888; font-size: 12px">{{ item.buyNum || 0 }}人报名</div> -->
                    </div>
                    <div class="skBtn">试看</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第五屏公开直播课 -->
      <!-- <div class="couserBox"
           style="background: #fff; padding-top: 121px">
        <div class="w">
          <div class="c1">直播公开课</div>
          <div class="c2">
            借助网络直播开展的继续教育课程，具有实时互动、灵活便捷、更新及时等特点，能实现优质资源共享，降低学习成本，提升学习自主性。
          </div>

          <div class="swthc">
            <div :class="liveIndex == '0' ? 'nav1' : 'nav2'"
                 @click="navSwthc('0')">继续教育</div>
            <div :class="liveIndex == '1' ? 'nav1' : 'nav2'"
                 @click="navSwthc('1')">职业教育</div>
          </div>

          <div class="zblist">
            <div v-if="zbEmpty"
                 style="width: 100%; text-align: center; margin-top: 150px; font-size: 20px">暂无直播数据~</div>
            <div class="abBox"
                 v-for="item in zbList"
                 :key="item.id"
                 :title="item.name">
              <div>
                <div :title="item.name"
                     v-if="item.image == null"
                     class="ab1"
                     style="position: relative; display: flex; justify-content: center; align-items: center;">
                  <img class="ab1Img"
                       style="border-radius: 8px 8px 0 0 "
                       src="../assets/indexImg/noimg.png"
                       alt="安徽继续教育网" />

                  <div class="ab1Text">
                    {{ item.name }}
                  </div>
                </div>
                <div v-else
                     class="ab1">
                  <img :title="item.name"
                       class="ab1"
                       :src="item.classImage"
                       :alt="item.name" />
                </div>

              </div>

              <div class="ab2">
                <div class="ab3">{{ item.name }}</div>
                <div class="ab4">直播时间：{{ item.startTime }}</div>
              </div>

              <div class="teach">
                <div class="tx">
                  <div>
                    <img style="margin-top: 2px"
                         src="../assets/indexImg/zblogo.png"
                         alt="安徽继续教育网" />
                  </div>
                  <div class="txname">{{ item.teacherName }}</div>
                </div>

                <div class="yyBtn"
                     @click="noyy">立即预约</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 第六屏关于冠成 -->
      <div class="couserBox"
           style="background: #fff; padding-top: 121px">
        <div class="w">
          <div class="c1">关于冠成教育科技有限公司</div>
          <div class="c2">公司专业并深耕教育培训行业，13年行业经验专业值得信赖</div>
          <img class="gyBgc"
               src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744161658536.png"
               alt="安徽继续教育网" />

          <div class="flexCenter">
            <div class="navbsnw">
              <div :class="bsnwIndex == '0' ? 'bsnwBoxActive bsnwBox' : 'bsnwBox'"
                   @click="bsnwTab('0')">行业经验</div>
              <div :class="bsnwIndex == '1' ? 'bsnwBoxActive bsnwBox' : 'bsnwBox'"
                   @click="bsnwTab('1')">发展历程</div>
              <div :class="bsnwIndex == '2' ? 'bsnwBoxActive bsnwBox' : 'bsnwBox'"
                   @click="bsnwTab('2')">师资团队</div>
              <div :class="bsnwIndex == '3' ? 'bsnwBoxActive bsnwBox' : 'bsnwBox'"
                   @click="bsnwTab('3')">教学服务</div>
              <div :class="bsnwIndex == '4' ? 'bsnwBoxActive bsnwBox' : 'bsnwBox'"
                   @click="bsnwTab('4')">学员心声</div>
              <div :class="bsnwIndex == '5' ? 'bsnwBoxActive bsnwBox' : 'bsnwBox'"
                   @click="bsnwTab('5')">合作单位</div>
            </div>
          </div>
          <!-- 行业经验 -->
          <div class="navBanner"
               v-if="bsnwIndex == 0">
            <div class="navLeft">
              <div class="navHead">
                <img style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: -1"
                     src="../assets/indexImg/image@2x.png"
                     alt="安徽继续教育网" />
                <div>安徽冠成教育科技有限公司——专技教育、职业教育专业培训机构</div>
                <div style="font-size: 14px; font-weight: 400; margin-top: 9px">
                  秉承“诚信、合作、共享、创新”理念，愿与有志之士共同推进中国教育信息化进程。
                </div>
              </div>
              <div class="navText">
                <div class="n1">
                  <div class="n2"><span style="font-size: 30px">13</span>年</div>
                  <div class="n3">公司是国家级高新技术企业一员，其核心团队十三年来致力于继续教育领城。</div>
                </div>

                <div class="n1">
                  <div class="n2"><span style="font-size: 30px">10</span>万+</div>
                  <div class="n3">公司已累计究成10万+专业人才的继续教育培训工作，为社会输入大量专业人才。</div>
                </div>

                <div class="n1"
                     style="margin-right: 0">
                  <div class="n2"><span style="font-size: 30px">省</span>级继续教育基地</div>
                  <div class="n3">2014 年公司获批省级继教基地，2018 - 2024 年三度荣获“国家级高新技术企业”称号。</div>
                </div>

                <div class="n4">
                  <div class="n2"><span style="font-size: 30px">1000</span>万+</div>
                  <div class="n3">一千余万次教学视频播放量为学员提供稳定、高效、便 捷的在线视频播放教学服务。</div>
                </div>
                <div class="n4"
                     style="margin-right: 0">
                  <div class="n2"><span style="font-size: 30px">20</span>万+</div>
                  <div class="n3">20余万种培训课程，课程资源覆盖各个领城的专业继续 人才以及职业教育培训领城。</div>
                </div>
              </div>
            </div>
            <div class="navRight">
              <img src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/09/images_1744162901195.png"
                   alt="安徽继续教育网" />
              <div style="display: flex; justify-content: center; width: 100%">
                <a class="btnShop"
                   rel="nofollow"
                   target="_blank"
                   href="https://ahgcjykjyxgs.qiyukf.com/client?k=dafbd24366a8c31bb28f2737a1b7698e&wp=1&robotShuntSwitch=0&templateId=8136501&language=zh-cn&t=安徽继续教育网">
                  <div>其他问题找客服</div>
                  <div style="margin-left: 4px"><img src="../assets/indexImg/jt.png"
                         alt="安徽继续教育网" /></div>
                </a>
              </div>
            </div>
          </div>
          <!-- 发展历程 -->
          <div class="navBanner"
               style="margin-top: 0"
               v-if="bsnwIndex == 1">
            <img class="fzjl"
                 src="https://gcjy-images-cdn.ahsjxjy.com/doujuanApi/prod/DouJuan/images/2025/04/24/images_1745481881281.png"
                 alt="安徽继续教育网" />
          </div>
          <!-- 师资团队 -->
          <div class="navBanner"
               v-if="bsnwIndex == 2">
            <sztd></sztd>
          </div>

          <!-- 教学服务 -->
          <div class="navBanner"
               style="margin-top: 0"
               v-if="bsnwIndex == 3">
            <jxfw></jxfw>
          </div>

          <!-- 学员心声 -->
          <div class="navBanner"
               v-if="bsnwIndex == 4">
            <xyxs :evaluateVoList="evaluateVoList"></xyxs>
          </div>

          <!-- 合作单位 -->
          <div class="navBanner"
               v-if="bsnwIndex == 5">
            <hzdw></hzdw>
          </div>
        </div>
      </div>

      <!-- 第七屏科普专区 -->
      <div class="couserBox"
           style="background: #fff; padding-top: 206px">
        <div class="w">
          <div class="c1">科普专区 在线答疑</div>
          <div class="c2">解决你在科普课程中的各类困惑，从理论知识到实际应用，全方位为你的科普学习保驾护航，轻松开启高效学习之旅。</div>
          <kpzq></kpzq>
        </div>
      </div>
    </div>
    <flotRight v-if="flotRightShow" />

    <pcBottom></pcBottom>

    <div class="tk"
         v-if="bmShow">
      <div class="wtkBox">
        <img class="tkBac"
             src="../assets/indexImg/tkbgc@2x.png"
             alt="" />

        <img class="closeBox"
             src="../assets/indexImg/Vector@2x.png"
             alt=""
             @click="closeOpen" />

        <div class="wxTtile">温馨提示</div>

        <div class="wx2">{{ bmText }}前往<span style="color: #2d72f3">继续教育专区</span>选课购买。</div>

        <div class="wxBtn"
             @click="goBm">立即前往报名</div>
      </div>
    </div>

    <!-- 首页弹框 -->
    <div class="flowTk"
         v-if="tkShow">
      <div class="tkBox">
        <img @click="tkShow = false"
             class="close"
             src="../assets/indexImg/close.png"
             alt="">
        <img @click="toUrl"
             class="tkImg"
             :src="adPicture.picUrl"
             alt=""></img>
      </div>
    </div>
    <!-- 邀请新人弹框 -->
    <el-dialog title="平台邀请新用户，积分奖励拿到手软！"
               :visible.sync="dialogVisible"
               class="newUserbox">
      <div class="newsUsertext">
        <div class="userTitle">邀请好友加入平台，轻松赚积分，可兑换好礼、抵扣课程费用，福利多多！以下是详细规则：</div>
        <div><img src="../assets/images/image 37@2x.png"
               alt=""
               class="newIcon"></div>
        <div>
          <div class="mtp12">
            <span style="font-weight: 600;margin-top: 16px;">一、参与条件​</span><br />

            所有平台注册用户均可参与，分享平台链接邀请好友，开启积分赚取之旅。<br />
          </div>

          <div class="mtp12">
            <span style="font-weight: 600">二、新用户判定</span> ​<br />

            系统精准判定：新用户指从未在本平台注册过的用户。若好友已注册，邀请人无法获得积分。<br />
          </div>
          <div class="mtp12">
            <span style="font-weight: 600"> 三、邀请步骤</span> ​<br />
            <div class="liucheng">
              <span>点击底部按钮获取链接</span>
              <img src="../assets/images/Group 1169@2x.png"
                   alt="">
              <span>分享链接给好友</span>
              <img src="../assets/images/Group 1169@2x.png"
                   alt="">

              <span>好友购买课程</span>
              <img src="../assets/images/Group 1169@2x.png"
                   alt="">

              <span>您获取积分</span>

            </div>
            <!-- 点击底部“获取链接分享好友”按钮将链接分享给好友（微信、QQ、短信等均可）。​
            好友通过链接注册登录，即绑定为你的被邀请用户，好友在平台的每一笔消费你都可以获得积分。 -->
          </div>
          <div class="mtp12">
            <span style="font-weight: 600">四、积分获取规则​<br /></span>
            ​ 新用户购买产品并支付成功，邀请人获相应积分，​积分与好友消费金额等额，如好友消费 180 元，邀请人得 180 积分。​
            无时间限制，好友任何时候购买支付成功，邀请人均可获积分。​好友订单退款，邀请人对应积分将被扣除。 好友支付成功后，24
            小时内发放积分。特殊情况延迟到账，平台会发通知说明。
          </div>
          <div class="mtp12">
            <span style="font-weight: 600"> 五、积分价值、用法 <br></span>
            ​ 30 积分 = 1 元，积少成多可攒 “小财富”。​积分可在平台商城兑换精美商品兑换的商品不退不换。​
            购买课程时抵扣现金（具体规则按平台规定） 在平台 “学习中心 — 积分商城”
            查看积分明细（获取、使用、过期等）和查看商品列表
          </div>
          <div class="mtp12">
            <span style="font-weight: 600"> 六、其他说明​ <br></span>
            平台监控邀请行为，不正当手段（虚假注册、恶意下单等）获取积分者，将被取消资格，情节严重者追究法律责任。​
            本规则最终解释权归平台，调整修改会通过公告通知，请注意查看。 点击获取链接邀请新用户
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: center;">
        <div class="newsBtn"
             @click="inviteNewUsers">点击获取链接邀请新用户</div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import headers from './component/head.vue';
import pcBottom from './component/bottom.vue';
import Baywindow from './component/Baywindow.vue';
import flotRight from '@/views/component/flotRight.vue';
import sztd from './component/sztd.vue';
import jxfw from './component/jxfw.vue';
import xyxs from './component/xyxs.vue';
import hzdw from './component/hzdw.vue';
import kpzq from './component/kpzq.vue';
import { getList, jxjyClass, findCourseListByRecommend, jxjyTuiJianClass, toAllReadyBuy, getShareUrl } from '../api/index';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    headers,
    sztd,
    jxfw,
    xyxs,
    hzdw,
    kpzq,
    pcBottom,
    Baywindow,
    flotRight
  },

  data() {
    // 这里存放数据
    return {
      img1: require('../assets/indexImg/11@2x.png'),
      img2: require('../assets/indexImg/22@2x.png'),
      img3: require('../assets/indexImg/33@2x.png'),
      img4: require('../assets/indexImg/44@2x.png'),
      img5: require('../assets/indexImg/55@2x.png'),
      img6: require('../assets/indexImg/66@2x.png'),
      img7: require('../assets/indexImg/77@2x.png'),
      img8: require('../assets/indexImg/88@2x.png'),
      img9: require('../assets/indexImg/99@2x.png'),
      img10: require('../assets/indexImg/1010@2x.png'),
      zyImg1: require('../assets/indexImg/znzz.png'),
      zyImg2: require('../assets/indexImg/rj.png'),
      zyImg3: require('../assets/indexImg/xxjs.png'),
      zyImg4: require('../assets/indexImg/jsj.png'),
      zyImg5: require('../assets/indexImg/qkljs.png'),
      className: '',
      localValue: '0702',
      zypxCodeList: [], //职业培训分类
      jxjyCodeList: [], //继续教育分类
      numData: {}, //学习人数
      kstdCodeList: [],
      jyShow: false,
      jxjyHotCodeList: [], //专业技术人员继续教育
      tzggList: [], //政策法规
      hyzxList: [], //行业资讯
      zyjsList: [], //专业技术的课程数组
      zyjsEmpty: false,
      recommendEmpty: false,
      recommendCourseCodeList: [], //课程资源库推荐课程
      recommendCourseList: [],
      zypxHotCodeList: [], //职业培训的高薪之路
      codeExtendInfo: {}, //职业的数据
      courseTabIndex: 0,
      jxjyLiveCourseList: [], //继续教育的直播
      zypxLiveCourseList: [], //职业培训的直播
      zbList: [], //展示的直播
      liveIndex: 0,
      zbEmpty: false,
      bsnwIndex: 0,
      jxjyIndex: null,
      evaluateVoList: [],
      flotRightShow: false,
      index: '',
      list1: [], //推荐课程第一行
      list2: [], //推荐课程第二行
      bmShow: false,
      dialogVisible: false,
      shareUrl: '', //邀请链接
      bmText: '',
      adPicture: '',
      tkShow: false
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    toUrl() {
      console.log(this.adPicture);
      if (this.adPicture.jumpway == '02') {
        //外部跳转
        window.open(this.adPicture.picDesc);
      } else {
        return false;
      }
    },
    toAllReadyBuy() {
      toAllReadyBuy().then(res => {
        if (localStorage.getItem('bmShow')) {
          this.bmShow = false;
          return false;
        }
        if (res.data.data.msg == '') {
          this.bmShow = false;
        } else {
          this.bmShow = true;
        }
        this.bmText = res.data.data.msg;
      });
    },
    //没报名去选课
    goBm() {
      this.$router.push({
        path: '/lsitFs',
        query: {
          fCodeNo: '0702'
        }
      });
    },
    //10s后关闭弹框，并且不在弹框
    closeOpen() {
      this.bmShow = false;
      localStorage.setItem('bmShow', false);
    },
    jxjyTuiJianClass() {
      jxjyTuiJianClass().then(res => {
        this.list1 = res.data.data.listOne;
        this.list2 = res.data.data.listTwo;
      });
    },
    noyy() {
      this.$confirm('功能正在开发中 ~', '温馨提示', {
        confirmButtonText: '确定',
        type: 'info'
      })
        .then(() => {})
        .catch(() => {});
    },
    //去资讯详情
    goFg(id, type, index) {
      console.log(id, type, index);

      this.$router.push({
        path: '/tzgg',
        query: {
          id: id,
          type: type,
          index: index
        }
      });
    },
    //邀请新人
    handleInvited() {
      this.dialogVisible = true;
    },
    //复制链接按钮
    inviteNewUsers() {
      getShareUrl().then(res => {
        if (res.data.code == 200) {
          this.shareUrl = res.data.msg;

          const textarea = document.createElement('textarea');
          if (this.shareUrl != null && this.shareUrl != '') {
            textarea.value = this.shareUrl;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
              document.execCommand('copy');
              this.$message({
                message: '链接复制成功 快去分享给好友吧!',
                type: 'success',
                duration: 1000
              });
              this.tip = '链接复制成功 快去分享给好友吧!';
              setTimeout(() => {
                this.tip = '';
              }, 2000);
            } catch (err) {
              this.$message({
                message: '复制失败！',
                duration: 800
              });
              console.error('复制失败:', err);
            }
            document.body.removeChild(textarea);
          } else {
            this.$message({
              message: '复制失败！',

              duration: 800
            });
          }
        }
      });
    },
    //去班级详情
    goDetail(id, type) {
      if (type == '1') {
        this.$router.push({
          path: '/classDetail2',
          query: {
            classId: id
          }
        });
      } else {
        this.$router.push({
          path: '/resources',
          query: {
            courseId: id
          }
        });
      }
    },
    bsnwTab(id) {
      this.bsnwIndex = id;
    },
    navSwthc(id) {
      this.liveIndex = id;
      if (id == '0') {
        this.zbList = this.jxjyLiveCourseList;
        if (this.zbList.length == 0) {
          this.zbEmpty = true;
        } else {
          this.zbEmpty = false;
        }
      } else {
        this.zbList = this.zypxLiveCourseList;
        if (this.zbList.length == 0) {
          this.zbEmpty = true;
        } else {
          this.zbEmpty = false;
        }
      }
    },
    changeZyhot(item) {
      console.log(item);
      this.codeExtendInfo = item.codeExtendInfo;
      this.$router.push({
        path: '/zyjy',
        query: {
          fCodeNo: item.codeNo //第一级
        }
      });
    },
    findCourseListByRecommend(id, index) {
      this.courseTabIndex = index;
      findCourseListByRecommend({ codeId: id }).then(res => {
        console.log(res.data);
        this.recommendCourseList = res.data.data;
        if (res.data.data.length == 0) {
          this.recommendEmpty = true;
        } else {
          this.recommendEmpty = false;
        }
      });
    },
    jxjyClass(codeId, index) {
      this.jxjyIndex = index;
      jxjyClass({ codeId: codeId }).then(res => {
        console.log(res.data);
        if (res.data.data.length == 0) {
          this.zyjsEmpty = true;
        } else {
          this.zyjsEmpty = false;
        }
        this.zyjsList = res.data.data;
      });
    },
    //挑报名选课继续教育
    goXk(item) {
      console.log(item);
      this.$router.push({
        path: '/lsitFs',
        query: {
          fCodeNo: '0702',
          codeNo: item.codeNo,
          codeName:item.codeName
        }
      });
    },
    //挑报名选课继续教育
    goTQ() {
      this.$router.push('/resourcesList');
    },
    goKstd(item) {
      console.log(item,'899');
      
      if (item.codeNo == '0705') {
        this.$router.push('/zyjy');
      } else {
        this.$router.push({
          path: '/lsitFs',
          query: {
            fCodeNo:item.codeNo,
            codeName1:item.codeName
          }
        });
      }
    },
    getList() {
      getList().then(res => {
        if (res.data.data == '01') {
          window.location.href = 'https://m.ahsjxjy.com';
          // window.location.href = 'http://192.168.1.123:8800/';
          return false;
        }
        this.adPicture = res.data.data.adPicture;
        if (this.adPicture !== '' && this.adPicture !== null && this.adPicture !== undefined) {
          this.tkShow = true;
        } else {
          this.tkShow = false;
        }
        console.log(this.adPicture, 111);

        this.zypxCodeList = res.data.data.zypxCodeList; //专技教育培训
        this.jxjyCodeList = res.data.data.jxjyCodeList; //职业技术培训
        this.numData = res.data.data.numData; //浏览人数
        this.kstdCodeList = res.data.data.kstdCodeList; //快速通道
        this.jxjyHotCodeList = res.data.data.jxjyHotCodeList; //专业技术人员继续教育
        // setTimeout(() => {
        //   this.jxjyClass(this.jxjyHotCodeList[0].id, 0);
        // }, 500);
        this.tzggList = res.data.data.tzggList; //政策法规
        this.hyzxList = res.data.data.hyzxList; //行业资讯
        this.zbList = res.data.data.jxjyLiveCourseList;
        if (res.data.data.jxjyLiveCourseList.length == 0) {
          this.zbEmpty = true;
        } else {
          this.zbEmpty = false;
        }
        this.jxjyLiveCourseList = res.data.data.jxjyLiveCourseList; //继续教育的直播
        this.zypxLiveCourseList = res.data.data.zypxLiveCourseList; //职业培训的直播
        this.evaluateVoList = res.data.data.evaluateVoList; //学员心声
        this.recommendCourseCodeList = res.data.data.courceZykCodeList; //课程资源库推荐课程
        setTimeout(() => {
          this.findCourseListByRecommend(this.recommendCourseCodeList[0].ID, 0);
        }, 500);
        this.zypxHotCodeList = res.data.data.zypxHotCodeList; //职业培训的高薪之路
        res.data.data.zypxHotCodeList.forEach(v => {
          if (v.codeExtendInfo.infoOne !== null) {
            v.codeExtendInfo.infoOneTitle = v.codeExtendInfo.infoOne.split(';')[0];
            v.codeExtendInfo.infoOne = v.codeExtendInfo.infoOne.split(';').pop();
          }
          if (v.codeExtendInfo.infoTwo !== null) {
            v.codeExtendInfo.infoTwoTitle = v.codeExtendInfo.infoTwo.split(';')[0];
            v.codeExtendInfo.infoTwo = v.codeExtendInfo.infoTwo.split(';').pop();
          }
          if (v.codeExtendInfo.infoThree !== null) {
            v.codeExtendInfo.infoThreeTitle = v.codeExtendInfo.infoThree.split(';')[0];
            v.codeExtendInfo.infoThree = v.codeExtendInfo.infoThree.split(';').pop();
          }
          if (v.codeExtendInfo.infoFour !== null) {
            v.codeExtendInfo.infoFourTitle = v.codeExtendInfo.infoFour.split(';')[0];
            v.codeExtendInfo.infoFour = v.codeExtendInfo.infoFour.split(';').pop();
          }
          this.codeExtendInfo = res.data.data.zypxHotCodeList[0].codeExtendInfo;
        });
        this.codeExtendInfo.codeName = res.data.data.zypxHotCodeList[0].codeName;
        console.log(res.data.data.zypxHotCodeList);
      });
    },
    handleZy(index) {
      this.codeExtendInfo = this.zypxHotCodeList[index].codeExtendInfo;
      this.codeExtendInfo.codeName = this.zypxHotCodeList[index].codeName;
      this.codeExtendInfo.codeNo = this.zypxHotCodeList[index].codeNo;
      this.codeExtendInfo.xb = index;
    },
    searClass(id) {
      if (this.className == '' && id !== 1) {
        return false;
      }
      this.localValue = {
        localValue: '',
        className: this.className
      };
      console.log(this.$route.path);
      this.$emit('updateParentValue', this.localValue); // 当输入框的值发生变化时，通过$emit事件告知父组件更新值
      if (this.$route.path !== '/lsitFs') {
        this.$router
          .push({
            path: '/classSearChList',
            query: {
              className: this.className
            }
          })
          .catch(err => {
            console.log('重复路由');
          });
      }
    },
    goMore() {
      this.$router.push({
        path: '/lsitFs',
        query: {
          fCodeNo: '0702'
        }
      });
    },
    handleScroll() {
      // 获取滚动条位置
      if (document.documentElement.scrollTop > 890) {
        this.flotRightShow = true;
      } else {
        this.flotRightShow = false;
      }

      if (this.$refs.heads) {
        if (document.documentElement.scrollTop > 90) {
          if (this.$refs.heads.style.opacity == '0') {
            return false;
          } else {
            this.$refs.heads.style.opacity = '0';
            this.$refs.heads.style.transition = 'all 0.3s linear';
          }
        } else if (document.documentElement.scrollTop == 0) {
          this.$refs.heads.style.opacity = '1';
          this.$refs.heads.style.transition = 'all 0.3s linear';
        }
      }
    },
    handleMouseEnter() {
      this.$refs.heads.style.opacity = '1';
      this.$refs.heads.style.transition = 'all 0.3s linear';
      console.log();
    },
    handleMouseleave() {
      if (document.documentElement.scrollTop == 0) {
        return false;
      }
      this.$refs.heads.style.opacity = '0';
      this.$refs.heads.style.transition = 'all 0.3s linear';
      console.log(123);
    },
    //跳转职业教育
    gotoListFs(codeExtendInfo) {
      console.log(codeExtendInfo.codeNo);

      this.$router.push({
        path: '/zyjy',
        query: {
          fCodeNo: codeExtendInfo.codeNo,
          xb: codeExtendInfo.xb
        }
      });
    },
    //去集体报名
    handleJiti() {
      this.$router.push({
        path: '/jiti'
      });
    },
    gotoZydetail(id, id2) {
      this.$router.push({
        path: '/zyjy',
        query: {
          fCodeNo: id, //第一级
          codeNo: id2 //第二级
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(localStorage.getItem('bmShow'), 1111);
    // this.bmShow = localStorage.getItem('bmShow')
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    console.log(isMobile);
    if (isMobile) {
      window.location.href = 'https://m.ahsjxjy.com';
      // window.location.href = 'http://192.168.1.123:5050/';
    }
    this.getList();
    this.jxjyTuiJianClass();
    this.toAllReadyBuy();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.imgText {
        font-size: 15px;
        font-family: kaiti;
        text-align: center;
        padding: 0px 10px;
        font-weight: bold;
        color: rgb(53, 95, 217);
        position: relative;
        z-index: 2;
      }
.flowTk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  overflow: hidden;
  display: flex;
  justify-content: center;
  .tkBox {
    position: relative;
    .close {
      position: absolute;
      top: 80px;
      right: 0px;
      z-index: 99;
      width: 50px;
      cursor: pointer;
    }
    .tkImg {
      width: 600px;
      margin-top: 80px;
      cursor: pointer;
    }
  }
}
.tk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  .wtkBox {
    width: 440px;
    height: 193px;
    position: relative;
    padding: 26px 29px;
    .tkBac {
      position: absolute;
      top: 0;
      left: 0;
      width: 447px;
      height: 209px;
      z-index: -1;
    }
    .closeBox {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 14px;
      right: 15px;
      cursor: pointer;
    }

    .wxTtile {
      font-size: 18px;
      color: #333333;
    }
    .wx2 {
      margin-top: 14px;
      font-size: 16px;
      color: #333;
    }
    .wxBtn {
      margin-top: 23px;
      width: 120px;
      height: 40px;
      background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
      box-shadow: 0px 3px 4px 0px rgba(21, 85, 202, 0.31);
      border-radius: 20px 20px 20px 20px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      cursor: pointer;
    }
  }
}
.btnShop {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align: center;
  color: #4076f6;
  font-size: 16px;
  font-weight: 500;
  width: 200px;
  height: 48px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid;
  border-image: linear-gradient(97deg, rgba(149, 181, 255, 1), rgba(64, 147, 246, 1)) 1 1;
  img {
    width: 26px !important;
    height: 12px;
  }
}
.flexCenter {
  display: flex;
  justify-content: center;
}
.w {
  width: 1400px;
}
.bgc {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  .fsk {
    margin-top: 186px;
    width: 1048px;
    display: flex;
    justify-content: center;
    .txt1 {
      margin-top: 15px;
      margin-bottom: 24px;
      color: #fff;
      font-size: 18px;
      text-align: center;
    }
    .swInput {
      display: flex;
      .searCh {
        width: 696px;
        height: 52px;
        background: rgba(255, 255, 255, 0.3);
        color: #fff;
        border: 0 !important;
        border-radius: 6px 0px 0px 6px;
        font-size: 16px;
        padding-left: 24px;
      }
      input::placeholder {
        color: #fff !important; /* 设置颜色 */
      }
      .searBtn {
        width: 109px;
        height: 52px;
        background: linear-gradient(48deg, #6996ff 0%, #4076f6 100%);
        border-radius: 0px 6px 6px 0px;
        color: #ffffff;
        font-size: 18px;
        text-align: center;
        line-height: 52px;
        cursor: pointer;
      }
    }
    .listBox {
      position: relative;
      margin-top: 20px;
      width: 100%;
      height: 370px;
      background: rgba(2, 26, 61, 0.37);
      display: flex;
      border-radius: 6px 6px 6px 6px;
      padding: 23px 50px 25px 50px;
      backdrop-filter: blur(5px);
      .su {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1px;
        height: 90px;
        background: rgba(255, 255, 255, 0.2);
      }
      img {
        width: 20px;
        height: 20px;
      }
      .zjBox {
        width: 50%;
        font-size: 18px;
        .cpBox {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          height: 200px;
          .lBxp {
            cursor: pointer;
            // width: 80px;
            padding: 0 10px;
            height: 30px;
            background: rgba(255, 255, 255, 0);
            border-radius: 15px 15px 15px 15px;
            line-height: 30px;
            color: #ffffff;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-right: 4px;
            margin-bottom: 4px;
            text-align: center;
          }
          .lBxp:hover {
            background: rgba(255, 255, 255, 0.5) !important;
            border-radius: 15px 15px 15px 15px !important;
          }
          .lBxp:nth-child(4n) {
            margin-right: 0 !important;
          }
        }
        .btnMore {
          margin-top: 20px;
          width: 90px;
          height: 30px;
          border-radius: 15px 15px 15px 15px;
          border: 1px solid rgba(255, 255, 255, 0.6);
          cursor: pointer;
          text-align: center;
          line-height: 30px;
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
        }
        .btnMore:hover {
          color: #fff !important;
          border: 0 !important;
          background: #24bd59;
          border-radius: 15px 15px 15px 15px;
        }
        .btnMoreHover:hover {
          color: #fff !important;
          border: 0 !important;
          background: #ff8833;
          border-radius: 15px 15px 15px 15px;
        }
      }
    }
    .jiti {
      padding: 0 24px;
      width: 1048px;
      justify-content: space-between;
      height: 60px;
      background: rgba(2, 26, 61, 0.5);
      border-radius: 8px 8px 8px 8px;
      border: 0.5px solid rgba(255, 255, 255, 0.1);
      margin-top: 20px;
      display: flex;
      align-items: center;
      .jintuText {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        width: 79px;
        line-height: 22px;
        height: 22px;
        border-right: 1px solid rgba(255, 255, 255, 0.2);
        font-size: 16px;
        color: #ffffff;
      }
      .jinru_1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        margin-left: 15px;
      }
      .jinru_btn {
        width: 90px;
        height: 32px;
        border-radius: 16px 16px 16px 16px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .listBox2 {
      margin-top: 30px;
      width: 1048;
      display: flex;
      align-items: center;
      justify-content: space-between;
      backdrop-filter: blur(10px);
      .fwBox {
        width: 250px;
        height: 160px;
        background: rgba(2, 26, 61, 0.37);
        border-radius: 8px;
        border: 0.5px solid rgba(255, 255, 255, 0.1);
        cursor: pointer;
        .txt2 {
          display: flex;
          align-items: center;
          font-size: 16px;
          height: 22px;
          img {
            margin-top: 6px;
            width: 18px;
            height: 18px;
          }
        }
        .txt3 {
          padding-left: 30px;
          color: rgba(255, 255, 255, 0.6);
          font-size: 14px;
          margin-top: 8px;
        }
        .txt4 {
          text-align: center;
          line-height: 48px;
          color: #fff;
          font-size: 14px;
          opacity: 0.8;
        }
        .bor {
          margin: 0 auto;
          width: 160px;
          height: 0.5px;
          background: rgba(255, 255, 255, 0.2);
        }
      }
      .fwBox:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
  }
}
.jyBox {
  position: relative;
  width: 100%;
  height: 334px;
  background: #ffffff;
  box-shadow: 0px 10px 60px 0px rgba(64, 114, 246, 0.2);
  padding-top: 136px;
  .showBox {
    position: absolute;
    top: -45px;
    left: 50%;
    transform: translateX(-50%);
    width: 1300px;
    height: 90px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .courseBox {
      width: 285px;
      height: 90px;
      background: rgba(255, 255, 255, 0.7);
      box-shadow: 0px 10px 40px 0px rgba(1, 40, 111, 0.12);
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #ffffff;
      cursor: pointer;
      backdrop-filter: blur(41.3px);
      .txt2 {
        display: flex;
        align-items: center;
        font-size: 16px;
        height: 22px;
        img {
          margin-top: 4px;
          width: 22px;
          height: 22px;
        }
      }
      .txt3 {
        padding-left: 30px;
        color: #666666;
        font-size: 14px;
        margin-top: 8px;
      }
      .txt4 {
        display: none;
        text-align: center;
        line-height: 48px;
        color: #fff;
        font-size: 14px;
      }
    }
    .courseBox:hover {
      border: 0 !important;
      width: 285px !important;
      height: 140px !important;
      background: linear-gradient(180deg, #6996ff 0%, #4076f6 100%) !important;
      box-shadow: 0px 10px 80px 0px rgba(1, 40, 111, 0.08) !important;
      border-radius: 8px 8px 8px 8px !important;
      border-image: linear-gradient(135deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5)) 1 1 !important;
      transition: height 0.5s ease; /* 定义多个过渡 */
      .borBox {
        border: 1px solid rgba(255, 255, 255, 0.15);
      }
      .txt2 {
        display: flex !important;
        align-items: center !important;
        font-size: 16px !important;
        height: 22px !important;
        color: #ffffff !important;
        img {
          margin-top: 4px;
          width: 22px;
          height: 22px;
        }
      }
      .txt3 {
        padding-left: 30px !important;
        color: #ffffff !important;
        font-size: 14px !important;
        margin-top: 8px !important;
      }
      .txt4 {
        display: block;
      }
    }
  }
  .head1 {
    font-weight: bold;
    font-size: 30px;
    color: #333333;
  }
  .head2 {
    margin: 8px 0 40px 0;
    font-size: 16px;
    color: #888888;
  }
  .iconBox {
    width: 1400px;
    padding: 0 39px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .ib {
      position: relative;
      width: 297px;
      cursor: pointer;
      .showImg {
        opacity: 0;
        position: absolute;
        width: 100px;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
      }
      .txt9 {
        font-size: 14px;
        text-align: center;
      }

      img {
        width: 44px;
        height: 44px;
      }
    }
    .ib1 {
      position: relative;
      width: 297px;
      cursor: pointer;
      .showImg {
        opacity: 0;
        position: absolute;
        width: 100px;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
      }
      .txt9 {
        font-size: 14px;
        text-align: center;
      }

      img {
        width: 44px;
        height: 44px;
      }
    }
    .ib1:hover {
      .txt9 {
        font-size: 14px;
        text-align: center;
      }
      .showImg {
        opacity: 1 !important;
        transition: all 0.3s linear;
      }
    }
  }
  .ib:hover {
    .txt9 {
      font-size: 14px;
      text-align: center;
    }
    .showImg {
      opacity: 1 !important;
      transition: all 0.3s linear;
    }
  }
}
.kc {
  position: relative;
  width: 100%;
  height: 747px;
  display: flex;
  justify-content: center;
  .bgcs {
    position: absolute;
    top: 0;
    width: 100%;
    height: 747px;
    z-index: -1;
  }
  .kcList {
    height: 236px;
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    width: 1400px;
    border-radius: 10px 10px 10px 10px;
    justify-content: space-between;

    .kcB {
      width: 49.5%;
      height: 236px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      cursor: pointer;
      padding: 30px;
      display: flex;
      box-shadow: 0px 5px 15px 0px rgba(138, 138, 138, 0.16), inset 0px 20px 50px 0px #f0f3f9;
      .fm {
        width: 220px;
        height: 170px;
      }
      .fmImg {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        width: 100%;
        height: 100%;
      }
      .imgText {
        font-size: 15px;
        font-family: kaiti;
        text-align: center;
        padding: 0px 10px;
        font-weight: bold;
        color: rgb(53, 95, 217);
        position: relative;
        z-index: 2;
      }
      .bt {
        width: 380px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 16px;
        color: #000;
        margin: 10px 0 12px 0;
        font-weight: bold;
      }
      .fl {
        display: flex;
        margin-bottom: 12px;
        .flx {
          padding: 0 12px;
          height: 23px;
          text-align: center;
          line-height: 23px;
          background: rgba(64, 118, 246, 0.1);
          border-radius: 2px 2px 2px 2px;
          color: #4076f6;
          font-size: 14px;
          margin-right: 12px;
        }
      }
      .studyTime {
        margin-bottom: 8px;
        font-size: 14px;
        color: #656e7e;
      }
      .btm {
        margin-top: 8px;
        display: flex;
        color: #ff6632;
        align-items: center;
        .skBtn {
          width: 90px;
          height: 36px;
          background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          line-height: 36px;
          color: #fff;
          font-size: 12px;
          color: #fff;
          margin-left: 25px;
          box-shadow: 0px 5px 15px 0px rgba(64, 147, 246, 0.3);
        }
        .ljgm {
          margin-left: 12px;
          background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%) !important;
          box-shadow: 0px 5px 15px 0px rgba(196, 8, 12, 0.3) !important;
        }
      }
    }
    // .kcB:hover {
    //   .fm {
    //     /* 设置放大比例 */
    //     transform: scale(1.1) !important;
    //     /* 添加过渡效果 */
    //     transition: all 0.5s;
    //   }
    //   .bt {
    //     color: #4076f6 !important;
    //     /* 添加过渡效果 */
    //     transition: all 0.5s;
    //   }
    //   .flx {
    //     background: rgba(64, 118, 246, 0.1) !important;
    //     border-radius: 2px 2px 2px 2px !important;
    //     color: #4076f6 !important;
    //     /* 添加过渡效果 */
    //     transition: all 0.5s;
    //   }

    //   .skBtn {
    //     transition: opacity 1s ease; /* 添加过渡效果 */
    //     opacity: 1; /* 初始不透明度 */
    //   }
    // }
  }

  .newKcList {
    margin-top: 27px;
    width: 1400px;
    height: 330px;
    background: #ffffff;
    box-shadow: 0px 5px 15px 0px rgba(138, 138, 138, 0.16), inset 0px 20px 50px 0px #f0f3f9;
    border-radius: 10px 10px 10px 10px;
    padding: 30px 30px 0 30px;
    display: flex;
    justify-content: space-between;
    .newBox {
      width: 200px;
      cursor: pointer;
      .fmDiv {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 160px;
        overflow: hidden;
      }
      .fmImg {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
      }
      .imgText {
        font-size: 15px;
        font-family: kaiti;
        text-align: center;
        padding: 0px 10px;
        font-weight: bold;
        color: rgb(53, 95, 217);
        position: relative;
        z-index: 2;
      }
      img {
        width: 200px;
        height: 160px;
      }
      .ntext1 {
        width: 200px;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 10px 0 7px 0;
      }
      .nax {
        display: flex;
        justify-content: space-between;
        .na1 {
          width: 56px;
          height: 23px;
          background: #f6f6f6;
          border-radius: 2px 2px 2px 2px;
          text-align: center;
          line-height: 23px;
          color: #666666;
          font-size: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .pric {
        margin-top: 10px;
        color: #ff6632;
        display: flex;
        font-size: 20px;
      }
    }
  }
}
.zxBox {
  position: relative;
  display: flex;
  margin-top: 29px;
  width: 1400px;
  height: 340px;
  background: #ffffff;
  box-shadow: 0px 5px 15px 0px rgba(138, 138, 138, 0.16), inset 0px 20px 50px 0px #f0f3f9;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #ffffff;
  .xian {
    position: absolute;
    left: 50%;
    top: 65px;
    height: 120px;
    width: 1px;
    background: rgba(0, 0, 0, 0.1);
    transform: translateX(-50%);
  }
  .zbs {
    width: 50%;
    padding: 30px 30px 29px 30px;
    .headsw {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .z1 {
        color: #222222;
        font-weight: bold;
        font-size: 20px;
      }
      .z2 {
        display: flex;
        margin-top: 8px;
        color: #666666;
        font-size: 12px;
        cursor: pointer;
        img {
          margin-top: 2.5px;
          width: 12px;
          height: 12px;
        }
      }
    }
    .xwB {
      cursor: pointer;
      width: 100%;
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .xwContent {
        width: 400px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #222222;
        font-size: 16px;
      }
      .timer {
        color: #88888a;
        font-size: 14px;
      }
    }
    .xwB:hover {
      .xwContent {
        color: #4076f6 !important;
      }
      .timer {
        color: #4076f6 !important;
      }
    }
  }
}
.zyjs {
  width: 100%;
  height: 1080px;
  background: #ffffff;
  padding: 112px 0;
  display: flex;
  justify-content: center;
  .baners {
    width: 1400px;
    .js1 {
      font-weight: bold;
      font-size: 30px;
      color: #333333;
      text-align: center;
    }
    .js2 {
      font-size: 16px;
      color: #888888;
      text-align: center;
      margin-top: 8px;
      margin-bottom: 60px;
    }

    .navImgList {
      margin-top: 45px;
      display: flex;
      justify-content: space-between;
      .navBox {
        cursor: pointer;
        padding-top: 16px;
        width: 160px;
        height: 180px;
        margin-left: 88px;
        img {
          width: 160px;
          height: 87.33px;
        }
        .tx1 {
          margin-top: 16px;
        }
        .tx2 {
          display: none;
          font-size: 12px !important;
          text-align: center;
          margin-top: 8px;
          color: #fff;
        }
      }
      .navBox:nth-child(1) {
        margin-left: 0 !important;
      }
      .navBox:hover {
        background: linear-gradient(147deg, #6996ff 0%, #4093f6 100%);
        border-radius: 10px 10px 10px 10px;
        .tx1 {
          color: #fff !important;
        }
        .tx2 {
          display: block !important;
        }
      }
    }

    .navTent {
      display: flex;
      margin-top: 40px;
      height: 520px;

      .left_bgc {
        position: relative;
        width: 250px;
        height: 520px;
        .img1 {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }
        .img2 {
          width: 196px;
          height: 196px;
          position: absolute;
          bottom: 16px;
          right: -15px;
          z-index: 1;
        }
        .z2 {
          position: relative;
          z-index: 2;
          font-size: 14px;
          color: #fff;
          padding: 0 20px 0 20px;
          cursor: pointer;
        }
      }

      .right_bgc {
        margin-left: 43px;
        width: 1107px;
        height: 520px;
        background: #f9fbff;
        border-radius: 20px 20px 20px 20px;
        overflow: hidden;
        .right_head {
          position: relative;
          width: 100%;
          height: 120px;
          background: #dbe5fd;
          padding: 31px 15px;
          display: flex;
          color: #333;
          .tb1 {
            font-size: 22px;
            font-weight: bold;
          }
          .tb2 {
            margin-top: 8px;
            font-size: 14px;
          }
          img {
            position: absolute;
            top: 0;
            right: 0;
          }
          .rh1 {
            display: flex;
            margin-left: 42px;
            margin-top: 12px;
            .l1 {
              width: 100px;
              height: 38px;
              background: #ffffff;
              border-radius: 4px 4px 4px 4px;
              margin-left: 20px;
              text-align: center;
              line-height: 38px;
              font-size: 14px;
              color: #333333;
            }
          }
        }
        .rhi2 {
          padding: 30px 15px;
          .r1 {
            color: #4076f6;
            font-size: 22px;
            font-weight: bold;
          }
          .r2 {
            margin-top: 38px;
            display: flex;
            flex-wrap: wrap;
            .rbox:nth-child(2n) {
              margin-right: 0 !important;
            }
            .rbox {
              display: flex;
              margin-bottom: 40px;
              margin-right: 107px;
              .rb1 {
                width: 52px;
                height: 24px;
                background: rgba(64, 118, 246, 0.1);
                border-radius: 2px 2px 2px 2px;
                color: #4076f6;
                font-size: 12px;
                text-align: center;
                line-height: 24px;
              }

              .rb2 {
                margin-left: 8px;
                .rb3 {
                  color: #333333;
                  font-size: 18px;
                  width: 425px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                .rb4 {
                  width: 425px;
                  margin-top: 8px;
                  color: #656e7e;
                  font-size: 14px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
        .r3 {
          cursor: pointer;
          width: 150px;
          height: 48px;
          background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
          box-shadow: 0px 5px 15px 0px rgba(196, 8, 12, 0.3);
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          font-size: 18px;
          line-height: 48px;
          color: #fff;
        }
      }
    }
  }
}

.jyqj {
  position: relative;
  width: 100%;
  height: 1080px;
  padding: 196px 260px;
  display: flex;
  justify-content: center;
  .jyB1 {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
  }
  .tj1 {
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    color: #ffffff;
  }
  .tj2 {
    font-weight: 400;
    color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
    text-align: center;
    margin-top: 4px;
  }
  .jsmm {
    margin-top: 97px;
    display: flex;
    .left_mm {
      width: 443px;
      margin-top: 92px;
      .lt1 {
        font-weight: bold;
        font-size: 30px;
        color: #ffffff;
      }
      .lt2 {
        margin-top: 20px;
        width: 339px;
        font-size: 16px;
        color: #ffffff;
      }
      .lt3 {
        width: 300px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;
        .lt5 {
          display: flex;
          align-items: center;
          margin-right: 40px;
          margin-bottom: 20px;
          img {
            width: 20px;
            height: 20px;
            margin-top: 2px;
          }
          .lt6 {
            margin-left: 4px;
            color: #fff;
            font-size: 14px;
          }
        }
      }
      .lt4 {
        margin-top: 50px;
        display: flex;
        .btn2 {
          font-size: 16px;
          color: #ffffff;

          width: 150px;
          height: 48px;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          line-height: 48px;
          cursor: pointer;
          border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0)) 1 1;
        }
      }
    }
    .right_mm {
      width: 823px;
      display: flex;
      flex-wrap: wrap;
      margin-left: 120px;
      .rg1 {
        position: relative;
        margin-bottom: 20px;
        margin-right: 23px;
        width: 400px;
        height: 250px;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 10px 10px 10px 10px;
        border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0)) 1 1;
        padding: 32px 18px 26px 23px;
        img {
          width: 154px;
          height: 154px;
          position: absolute;
          right: 18px;
          bottom: 26px;
        }
        .rm1 {
          font-weight: bold;
          font-size: 18px;
          color: #ffffff;
        }
        .rm2 {
          margin-top: 15px;
          width: 182px;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          line-height: 16px;
        }
      }
      .rg1:nth-child(2n) {
        margin-right: 0 !important;
      }
    }
  }
}

.couserBox {
  position: relative;
  width: 100%;
  height: 1080px;
  display: flex;
  justify-content: center;
  padding-top: 94px;
  background: #f6f9fc;
  .c1 {
    position: relative;
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    color: #333333;
    z-index: 2;
  }
  .c2 {
    position: relative;
    z-index: 2;
    margin-top: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #888888;
    text-align: center;
  }
  .courNav {
    margin-top: 63px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(51, 51, 51, 0.1);
    height: 40px;
    .courseName {
      cursor: pointer;
      margin-right: 47px;
      height: 40px;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      text-align: center;
    }
    .courseNameActive {
      color: #4076f6 !important;
      border-bottom: 2px solid #4076f6 !important;
    }
    .courseName:last-child {
      margin-right: 0 !important;
    }
    .z21 {
      position: absolute;
      right: 0;
      top: -10px;
      width: 80px !important;
      height: 28px !important;
      text-align: center !important;
      line-height: 28px !important;
      display: flex;
      margin-top: 8px;
      color: #4076f6;
      font-size: 14px;
      cursor: pointer;
      padding-left: 10px;
      .z2Bac {
        margin-top: 7.5px;
        width: 14px;
        height: 14px;
        background: url('../assets/indexImg/Frame.png');
      }
    }
    .z21:hover {
      border-radius: 14px 14px 14px 14px;
      text-align: center !important;
      line-height: 28px !important;
      color: #fff;
      background: linear-gradient(92deg, #6996ff 0%, #4076f6 100%);
      .z2Bac {
        background: url('../assets/indexImg/fff.png') !important;
      }
    }
  }

  .couserList {
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 40px;

    .kcB {
      width: 220px;
      height: 300px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      cursor: pointer;
      overflow: hidden;
      .fm {
        width: 220px;
        height: 176px;
      }
      .fmImg {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        width: 100%;
        height: 100%;
      }
      .bt {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 16px;
        color: #000;
        margin: 10px 0 7px 0;
      }
      .fl {
        display: flex;
        .flx {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 56px;
          height: 23px;
          background: #f6f6f6;
          border-radius: 2px 2px 2px 2px;
          text-align: center;
          line-height: 23px;
          color: #666666;
          font-size: 12px;
          margin-right: 8px;
        }
      }
      .btm {
        margin-top: 12px;
        display: flex;
        color: #ff6632;
        position: relative;
        .skBtn {
          position: absolute;
          top: 0;
          right: 0;
          opacity: 0;
          width: 54px;
          height: 28px;
          background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          line-height: 28px;
          color: #fff;
          font-size: 12px;
        }
      }
    }
    .kcbRes {
      position: relative;
      width: 220px;
      height: 300px;
      margin-right: 16px;
      margin-bottom: 30px;

      .kcB:hover {
        position: absolute !important;
        bottom: 0px !important;
        // left: -10px !important;
        width: 240px !important;
        height: 328px !important;
        background: #ffffff !important;
        border-radius: 8px 8px 8px 8px !important;
        cursor: pointer !important;
        transform: translate(-10px);
        /* 添加过渡效果 */
        transition: all 0.2s linear;
        box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.08);
        .fm {
          width: 240px !important;
          height: 192px !important;
          /* 添加过渡效果 */
          transition: all 0.2s linear;
        }
        .skBtn {
          opacity: 1;
          /* 添加过渡效果 */
          transition: all 0.2s;
        }
        .bt {
          color: #4076f6 !important;
          transition: all 0.2s;
        }
        .flx {
          background: rgba(64, 118, 246, 0.1) !important;
          color: #4076f6 !important;
          transition: all 0.2s;
        }
      }
    }
    .kcbRes:nth-child(6n) {
      margin-right: 0 !important;
    }
  }

  .swthc {
    width: 200px;
    height: 44px;
    background: #f6f9fc;
    box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.06);
    border-radius: 25px 25px 25px 25px;
    border: 1px solid #f1f1f1;
    display: flex;
    margin: 60px auto 30px auto;

    .nav1 {
      width: 100px;
      height: 44px;
      background: #ffffff;
      border-radius: 25px 25px 25px 25px;
      text-align: center;
      line-height: 44px;
      font-size: 14px;
      cursor: pointer;
    }
    .nav2 {
      width: 100px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 14px;
      cursor: pointer;
      color: #666666;
    }
  }

  .zblist {
    display: flex;
    flex-wrap: wrap;
    .abBox {
      width: 335px;
      height: 302px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #f1f1f1;
      margin-right: 20px;
      margin-bottom: 30px;
      .ab1 {
        width: 335px;
        height: 160px;
      }
      .ab1Img {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        width: 335px;
        height: 160px;
      }
      .ab1Text {
        font-size: 15px;
        font-family: kaiti;
        text-align: center;
        padding: 0px 10px;
        font-weight: bold;
        color: rgb(53, 95, 217);
        position: relative;
        z-index: 2;
      }
      .ab2 {
        padding: 16px 20px 0 20px;
        .ab3 {
          width: 290px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: 500;
          font-size: 16px;
          color: #000000;
        }
        .ab4 {
          margin-top: 8px;
          width: 295px;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          padding-bottom: 15px;
          border-bottom: 1px solid #f1f1f1;
        }
      }

      .teach {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 55px;
        width: 100%;
        padding: 0 20px;
        .tx {
          display: flex;
          align-items: center;
          img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
          }
          .txname {
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            margin-left: 8px;
          }
        }

        .yyBtn {
          cursor: pointer;
          width: 90px;
          height: 36px;
          background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
          border-radius: 18px 18px 18px 18px;
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    .abBox:nth-child(4n) {
      margin-right: 0 !important;
    }
  }

  .gyBgc {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .navbsnw {
    position: relative;
    z-index: 2;
    margin-top: 50px;
    display: flex;
    .bsnwBox {
      width: 120px;
      height: 44px;
      background: #ffffff;
      border-radius: 24px 24px 24px 24px;
      text-align: center;
      line-height: 44px;
      cursor: pointer;
      font-size: 16px;
      color: #333333;
      margin-right: 16px;
    }
    .bsnwBoxActive {
      background: linear-gradient(97deg, #95b5ff 0%, #4093f6 100%) !important;
      color: #fff !important;
      opacity: 0.8 !important;
    }
  }

  .navBanner {
    margin-top: 70px;
    display: flex;
    position: relative;
    z-index: 2;
    .navLeft {
      width: 850px;
      height: 520px;
      background: rgba(50, 90, 210, 0.08);
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #dbe5fd;
      padding: 24px 20px;
      margin-top: 50px;
      .navHead {
        width: 790px;
        height: 110px;
        border-radius: 10px 10px 10px 10px;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        padding: 29px 0;
        text-align: center;
        position: relative;
      }
      .navText {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        .n1 {
          width: 250px;
          height: 170px;
          background: #ffffff;
          border-radius: 10px 10px 10px 10px;
          margin-right: 20px;
          padding: 26px 20px;
          .n2 {
            color: #4076f6;
            font-size: 14px;
          }
          .n3 {
            font-weight: 400;
            font-size: 14px;
            color: #656e7e;
          }
        }
        .n4 {
          margin-top: 20px;
          width: 385px;
          height: 150px;
          background: #ffffff;
          border-radius: 10px 10px 10px 10px;
          margin-right: 20px;
          padding: 26px 20px;
          .n2 {
            color: #4076f6;
            font-size: 14px;
          }
          .n3 {
            font-weight: 400;
            font-size: 14px;
            color: #656e7e;
          }
        }
      }
    }

    .navRight {
      margin-left: 90px;
      img {
        width: 520px;
      }
    }

    .fzjl {
      margin-top: 50px;
      width: 1464px;
    }
  }
}
.newsUsertext {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  .userTitle {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    width: 630px;
    height: 40px;
    background-image: url('../assets/images/Mask group@2x.png');
    background-size: cover;
    line-height: 40px;
    padding-left: 10px;
    position: relative;
  }
  .newIcon {
    position: absolute;
    top: 58px;
    right: 20px;
    width: 47px;
    height: 55px;
  }
}
.newsBtn {
  cursor: pointer;

  margin-top: 20px;
  width: 220px;
  height: 36px;
  background: #ff8833;
  box-shadow: 0px 4px 10px 0px rgba(255, 136, 51, 0.2);
  border-radius: 8px 8px 8px 8px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
}
.newUserbox {
  ::v-deep {
    .el-dialog {
      width: 670px;
      // height: 561px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
    }
    .el-dialog__header {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
    }
    .el-dialog__body {
      padding-top: 12px !important;
    }
  }
}
.mtp12 {
  margin-top: 12px;
}
.jtBox {
  cursor: pointer;

  width: 510px;
  height: 100px;
  img {
    width: 510px;
    height: 100px;
  }
}
.liucheng {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 7px;
  margin-bottom: 13px;
  span {
    display: inline-block;
    padding: 8px 10px;
    height: 32px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #f70004;
    background: rgba(255, 51, 55, 0.1);
    border-radius: 4px 4px 4px 4px;
  }
  img {
    width: 18px;
    height: 18px;
  }
}
</style>
